/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:49a4bf64-9e87-4b62-9b1a-08c566b249e1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_tHylrZ6QO",
    "aws_user_pools_web_client_id": "6694co7ie7nvne783of3a8j1uj",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://rlb6r7jemvarzmnmfoy3dwctx4.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-wk573xysdnbxppdqb3nylqhcaa",
    "aws_cloud_logic_custom": [
        {
            "name": "appConfiguratorRestApi",
            "endpoint": "https://tc9j4sn8qd.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "app-configurator-webapp104939-master",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
